(function() {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  var backdrop = document.getElementById('cart-drawer-backdrop');
  var closeBtn = document.getElementById('cart-drawer-close');
  var drawerContent = document.getElementById('cart-drawer-content');
  var drawerBody = document.getElementById('cart-drawer-body');
  var drawerFooter = document.getElementById('cart-drawer-footer');
  var isOpen = false;

  var settings = window.cartDrawerSettings || {};
  var freeShippingThreshold = settings.freeShippingThreshold || 50000;
  var currencySymbol = settings.currencySymbol || 'R$';
  var shippingRatesCache = {};
  var shippingRequestId = 0;
  var currentCartSignature = '';

  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return currencySymbol + ' ' + value;
  }

  function formatShippingPrice(price) {
    var amount = typeof price === 'number' ? price : parseFloat(String(price || '0').replace(',', '.'));
    if (!Number.isFinite(amount)) amount = 0;
    return formatMoney(Math.round(amount * 100));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getRoutesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function getCartSignature(cartData) {
    if (!cartData || !cartData.items) return '';
    return cartData.items.map(function(item) {
      return [item.variant_id || item.id, item.quantity, item.final_line_price || item.line_price].join(':');
    }).join('|') + ':' + cartData.total_price;
  }

  function getVariantTitle(item) {
    if (item.variant_options && item.variant_options.length > 0) {
      var filtered = item.variant_options.filter(function(opt) {
        return opt && opt !== 'Default Title';
      });
      if (filtered.length > 0) return filtered.join(' / ');
    }
    if (!item.variant_title || item.variant_title === 'Default Title') return '';
    return item.variant_title;
  }

  function getKitPropertiesHtml(item) {
    if (!item.properties) return '';
    var kitItems = [];
    Object.keys(item.properties).forEach(function(key) {
      if (key.indexOf('_Item') === 0) {
        var raw = String(item.properties[key]);
        if (item.product_title) {
          var escaped = item.product_title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          raw = raw.replace(new RegExp('^' + escaped + '\\s*—\\s*'), '');
        }
        kitItems.push(raw);
      }
    });
    if (kitItems.length === 0) return '';
    var html = '<ul class="text-xs text-gray-500 mt-1 space-y-0.5">';
    kitItems.forEach(function(val) {
      var display = val.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/null/g, '—');
      html += '<li>' + display + '</li>';
    });
    html += '</ul>';
    return html;
  }

  function isKitItem(item) {
    return item.properties && item.properties['_kit_type'];
  }

  function getProductImageUrl(item) {
    if (item.image) return item.image.replace(/_(small|medium|large)\./, '_160x.');
    if (item.featured_image && item.featured_image.url) return item.featured_image.url.replace(/_(small|medium|large)\./, '_160x.');
    return '';
  }

  function renderShippingProgress(cartData) {
    var percent = Math.min(100, Math.round((cartData.total_price / freeShippingThreshold) * 100));
    var message;
    if (cartData.total_price >= freeShippingThreshold) {
      message = 'Parabéns! Você ganhou <span class="font-semibold text-gray-900">Frete Grátis</span>';
    } else {
      var remaining = freeShippingThreshold - cartData.total_price;
      message = 'Faltam <span class="font-semibold text-gray-900">' + formatMoney(remaining) + '</span> para o frete grátis';
    }
    return (
      '<div class="px-6 pt-5 pb-2">' +
        '<div class="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden mb-2">' +
          '<div class="cart-shipping-progress h-full bg-gray-900 rounded-full transition-all duration-500" style="width: ' + percent + '%;"></div>' +
        '</div>' +
        '<p class="text-xs text-gray-600">' + message + '</p>' +
      '</div>'
    );
  }

  function renderItems(cartData) {
    var html = '<div class="px-6 py-4 space-y-6" id="cart-drawer-items">';
    cartData.items.forEach(function(item, index) {
      var line = index + 1;
      var variantTitle = getVariantTitle(item);
      var kitHtml = getKitPropertiesHtml(item);
      var imageUrl = getProductImageUrl(item);
      var imageHtml = imageUrl
        ? '<img src="' + imageUrl + '" alt="' + (item.image_alt || '').replace(/"/g, '&quot;') + '" class="w-full h-full object-cover" width="80" height="96" loading="lazy">'
        : '<div class="w-full h-full bg-gray-100"></div>';

      html += (
        '<div class="flex gap-4" data-cart-item data-line="' + line + '">' +
          '<a href="' + item.url + '" class="w-20 h-24 bg-gray-50 flex-shrink-0 overflow-hidden flex items-center justify-center">' + imageHtml + '</a>' +
          '<div class="flex-1 min-w-0 flex flex-col justify-between">' +
            '<div>' +
              '<div class="flex items-start justify-between gap-2">' +
                '<a href="' + item.url + '" class="text-sm font-medium text-gray-900 leading-tight hover:text-gray-600 transition-colors line-clamp-2">' + item.product_title + '</a>' +
                '<button type="button" class="cart-drawer-remove p-1 text-gray-400 hover:text-red-500 transition-colors flex-shrink-0 cursor-pointer" data-line="' + line + '" aria-label="Remover ' + item.product_title.replace(/"/g, '&quot;') + '">' +
                  '<svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>' +
                '</button>' +
              '</div>' +
              (kitHtml ? kitHtml : (variantTitle ? '<p class="text-xs text-gray-500 mt-0.5">' + variantTitle + '</p>' : '')) +
            '</div>' +
            '<div class="flex items-center justify-between mt-2">' +
              '<div class="cart-drawer-qty-bar flex items-center border border-gray-200">' +
                '<button type="button" class="cart-drawer-qty-btn w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50 transition-colors cursor-pointer" data-action="decrease" data-line="' + line + '" aria-label="Diminuir quantidade">' +
                  '<svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>' +
                '</button>' +
                '<span class="cart-drawer-qty-value w-8 text-center text-sm text-gray-900" data-line="' + line + '">' + item.quantity + '</span>' +
                '<button type="button" class="cart-drawer-qty-btn w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50 transition-colors cursor-pointer" data-action="increase" data-line="' + line + '" aria-label="Aumentar quantidade">' +
                  '<svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>' +
                '</button>' +
              '</div>' +
              '<span class="text-sm font-semibold text-gray-900 cart-drawer-line-price" data-line="' + line + '">' + formatMoney(item.line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    });
    html += '</div>';
    html += '<div id="cart-drawer-recommendations" class="min-h-[1px]"></div>';
    return html;
  }

  function renderEmptyState() {
    return (
      '<div class="flex-1 flex flex-col items-center justify-center px-6 py-12 text-center">' +
        '<svg class="w-12 h-12 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>' +
        '</svg>' +
        '<p class="text-sm text-gray-500 mb-6">Sua sacola está vazia.</p>' +
        '<a href="/collections/all" class="cart-drawer-btn-primary inline-flex items-center justify-center px-6 py-3 bg-black text-white text-sm font-medium transition-colors">' +
          'Continuar comprando' +
        '</a>' +
      '</div>'
    );
  }

  function renderFooter(cartData) {
    return (
      '<div class="border-b border-gray-100">' +
        '<button type="button" id="cart-drawer-shipping-toggle" class="w-full flex items-center justify-between px-6 py-4 text-sm text-gray-900 hover:bg-gray-50 transition-colors cursor-pointer" aria-expanded="false" aria-controls="cart-drawer-shipping-panel">' +
          '<span class="font-medium">Cálculo de frete</span>' +
          '<svg id="cart-drawer-shipping-icon" class="w-4 h-4 text-gray-500 transition-transform duration-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>' +
        '</button>' +
        '<div id="cart-drawer-shipping-panel" class="hidden px-6 pb-4">' +
          '<div class="flex gap-2">' +
            '<input type="tel" id="cart-drawer-shipping-cep" placeholder="00000-000" maxlength="9" inputmode="numeric" autocomplete="postal-code" class="cart-drawer-input flex-1 h-10 px-3 border border-gray-200 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:border-gray-900 transition-colors">' +
            '<button type="button" id="cart-drawer-shipping-calc" class="cart-drawer-btn-secondary h-10 px-4 border border-gray-900 text-sm font-medium text-gray-900 transition-colors cursor-pointer">Calcular</button>' +
          '</div>' +
          '<div id="cart-drawer-shipping-results" class="mt-3 space-y-2" aria-live="polite"></div>' +
        '</div>' +
      '</div>' +
      '<div class="flex items-center justify-between px-6 py-4">' +
        '<span class="text-sm font-medium text-gray-900">Subtotal</span>' +
        '<span id="cart-drawer-subtotal" class="text-sm font-semibold text-gray-900">' + formatMoney(cartData.total_price) + '</span>' +
      '</div>' +
      '<div class="px-6 pb-6 pt-2">' +
        '<a href="/checkout" class="cart-drawer-btn-primary block w-full px-4 py-3.5 bg-gray-900 text-white text-sm font-medium text-center transition-colors rounded-2xl">Finalizar compra</a>' +
      '</div>'
    );
  }

  function bindShippingToggle() {
    var toggle = document.getElementById('cart-drawer-shipping-toggle');
    var panel = document.getElementById('cart-drawer-shipping-panel');
    var icon = document.getElementById('cart-drawer-shipping-icon');
    if (toggle && panel) {
      toggle.addEventListener('click', function() {
        var isExpanded = panel.classList.toggle('hidden') === false;
        toggle.setAttribute('aria-expanded', isExpanded);
        if (icon) {
          icon.style.transform = isExpanded ? 'rotate(45deg)' : '';
        }
      });
    }
  }

  function bindShippingCalc() {
    var btn = document.getElementById('cart-drawer-shipping-calc');
    var input = document.getElementById('cart-drawer-shipping-cep');
    var results = document.getElementById('cart-drawer-shipping-results');
    var autoTimer = null;

    function setShippingLoading(loading) {
      if (!btn) return;
      btn.disabled = loading;
      btn.classList.toggle('opacity-60', loading);
      btn.classList.toggle('cursor-wait', loading);
      btn.textContent = loading ? 'Calculando...' : 'Calcular';
    }

    function renderShippingMessage(message, type) {
      if (!results) return;
      var color = type === 'error' ? 'text-red-500' : 'text-gray-500';
      results.innerHTML = '<p class="text-xs ' + color + '">' + message + '</p>';
    }

    function renderShippingRates(rates) {
      if (!results) return;
      if (!rates || rates.length === 0) {
        renderShippingMessage('Nenhuma opção de frete encontrada para este CEP.', 'error');
        return;
      }

      var html = '<div class="space-y-2">';
      rates.forEach(function(rate) {
        var delivery = rate.delivery_range || rate.delivery_date || '';
        html += (
          '<div class="flex items-start justify-between gap-3 border border-gray-100 px-3 py-2">' +
            '<div class="min-w-0">' +
              '<p class="text-xs font-medium text-gray-900">' + escapeHtml(rate.name || rate.source || 'Frete') + '</p>' +
              (delivery ? '<p class="text-[11px] text-gray-500 mt-0.5">' + escapeHtml(delivery) + '</p>' : '') +
            '</div>' +
            '<p class="text-xs font-semibold text-gray-900 whitespace-nowrap">' + formatShippingPrice(rate.price) + '</p>' +
          '</div>'
        );
      });
      html += '</div>';
      results.innerHTML = html;
    }

    function buildShippingQuery(cep) {
      var params = new URLSearchParams();
      params.set('shipping_address[zip]', cep);
      params.set('shipping_address[country]', 'Brazil');
      return params.toString();
    }

    function fetchPreparedShippingRates(cep, attempt) {
      var root = getRoutesRoot();
      var query = buildShippingQuery(cep);
      return fetch(root + 'cart/async_shipping_rates.json?' + query, {
        headers: { 'Accept': 'application/json' }
      }).then(function(res) {
        if (res.status === 202 || res.status === 204) {
          if (attempt >= 8) throw new Error('timeout');
          return new Promise(function(resolve) {
            setTimeout(resolve, 500);
          }).then(function() {
            return fetchPreparedShippingRates(cep, attempt + 1);
          });
        }
        if (!res.ok) throw new Error('shipping_rates_failed');
        return res.json();
      }).then(function(data) {
        if (!data.shipping_rates && attempt < 8) {
          return new Promise(function(resolve) {
            setTimeout(resolve, 500);
          }).then(function() {
            return fetchPreparedShippingRates(cep, attempt + 1);
          });
        }
        return data.shipping_rates || [];
      });
    }

    function fetchDirectShippingRates(cep) {
      var root = getRoutesRoot();
      var query = buildShippingQuery(cep);
      return fetch(root + 'cart/shipping_rates.json?' + query, {
        headers: { 'Accept': 'application/json' }
      }).then(function(res) {
        if (!res.ok) throw new Error('direct_shipping_rates_failed');
        return res.json();
      }).then(function(data) {
        return data.shipping_rates || [];
      });
    }

    function calculateShipping() {
      var cep = input ? input.value.replace(/\D/g, '') : '';
      if (cep.length !== 8) {
        renderShippingMessage('Digite um CEP válido.', 'error');
        return;
      }

      var cacheKey = currentCartSignature + ':' + cep;
      if (shippingRatesCache[cacheKey]) {
        renderShippingRates(shippingRatesCache[cacheKey]);
        return;
      }

      var requestId = ++shippingRequestId;
      setShippingLoading(true);
      renderShippingMessage('Buscando opções de frete...', 'info');

      var root = getRoutesRoot();
      var query = buildShippingQuery(cep);
      fetch(root + 'cart/prepare_shipping_rates.json?' + query, {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      })
        .then(function(res) {
          if (!res.ok && res.status !== 202) throw new Error('prepare_shipping_failed');
          return fetchPreparedShippingRates(cep, 0);
        })
        .catch(function() {
          return fetchDirectShippingRates(cep);
        })
        .then(function(rates) {
          if (requestId !== shippingRequestId) return;
          shippingRatesCache[cacheKey] = rates;
          renderShippingRates(rates);
        })
        .catch(function(err) {
          if (requestId !== shippingRequestId) return;
          console.error('[CartDrawer] Erro ao calcular frete:', err);
          renderShippingMessage('Não foi possível calcular o frete agora. Verifique as configurações de entrega da loja ou tente novamente.', 'error');
        })
        .finally(function() {
          if (requestId === shippingRequestId) setShippingLoading(false);
        });
    }

    if (input) {
      input.addEventListener('input', function(e) {
        var value = e.target.value.replace(/\D/g, '');
        if (value.length > 5) {
          value = value.slice(0, 5) + '-' + value.slice(5, 8);
        }
        e.target.value = value;
        if (autoTimer) clearTimeout(autoTimer);
        if (value.replace(/\D/g, '').length === 8) {
          autoTimer = setTimeout(calculateShipping, 450);
        } else if (results) {
          results.innerHTML = '';
        }
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          calculateShipping();
        }
      });
    }
    if (btn && input) {
      btn.addEventListener('click', calculateShipping);
    }
  }

  function bindContinueButton() {
    var btn = document.getElementById('cart-drawer-continue');
    if (btn) {
      btn.addEventListener('click', closeDrawer);
    }
  }

  function bindQuantityButtons() {
    if (!drawerBody) return;
    drawerBody.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-drawer-qty-btn');
      if (!btn) return;

      var line = parseInt(btn.getAttribute('data-line'), 10);
      var action = btn.getAttribute('data-action');
      var qtyEl = document.querySelector('.cart-drawer-qty-value[data-line="' + line + '"]');
      if (!qtyEl) return;

      var currentQty = parseInt(qtyEl.textContent, 10);
      var newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;

      if (newQty < 1) {
        changeQuantity(line, 0);
        var itemRow = document.querySelector('[data-cart-item][data-line="' + line + '"]');
        if (itemRow) itemRow.style.opacity = '0.5';
      } else {
        changeQuantity(line, newQty);
      }
    });
  }

  function bindRemoveButtons() {
    if (!drawerBody) return;
    drawerBody.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-drawer-remove');
      if (!btn) return;

      var line = parseInt(btn.getAttribute('data-line'), 10);
      changeQuantity(line, 0);

      var itemRow = document.querySelector('[data-cart-item][data-line="' + line + '"]');
      if (itemRow) {
        itemRow.style.opacity = '0.5';
        itemRow.style.pointerEvents = 'none';
      }
    });
  }

  function renderDrawer(cartData) {
    if (!drawerBody) return;
    currentCartSignature = getCartSignature(cartData);

    if (cartData.item_count === 0) {
      drawerBody.innerHTML = renderEmptyState();
      if (drawerFooter) drawerFooter.style.display = 'none';
    } else {
      drawerBody.innerHTML = renderShippingProgress(cartData) + renderItems(cartData);
      requestAnimationFrame(function() {
        var bar = document.querySelector('.cart-shipping-progress');
        if (bar) {
          bar.classList.remove('shipping-bar-animate');
          void bar.offsetWidth; // força reflow
          bar.classList.add('shipping-bar-animate');
        }
      });
      if (!drawerFooter && drawerContent) {
        drawerFooter = document.createElement('div');
        drawerFooter.id = 'cart-drawer-footer';
        drawerFooter.className = 'border-t border-gray-100 bg-white flex-shrink-0';
        drawerContent.appendChild(drawerFooter);
      }
      if (drawerFooter) {
        drawerFooter.style.display = '';
        drawerFooter.innerHTML = renderFooter(cartData);
      }
      bindShippingToggle();
      bindShippingCalc();
      bindContinueButton();
    }

    updateCartBadge(cartData.item_count);
  }

  function updateCartBadge(count) {
    var desktopCartBtn = document.querySelector('header button[data-cart-drawer-toggle]');
    if (desktopCartBtn) {
      var badge = desktopCartBtn.querySelector('span[class*="min-w-[18px]"]');
      if (badge) {
        if (count > 0) {
          badge.textContent = count;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      }
    }

    var mobileCartBtn = document.querySelector('#mobile-menu button[data-cart-drawer-toggle]');
    if (mobileCartBtn) {
      mobileCartBtn.textContent = 'Carrinho (' + count + ')';
    }
  }

  function fetchCartAndRender(callback) {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(res) { return res.json(); })
      .then(function(cartData) {
        renderDrawer(cartData);
        if (typeof callback === 'function') callback();
      })
      .catch(function(err) {
        console.error('[CartDrawer] Erro ao buscar carrinho:', err);
        if (typeof callback === 'function') callback();
      });
  }

  function setItemLoading(line, loading) {
    var item = document.querySelector('[data-cart-item][data-line="' + line + '"]');
    if (!item) return;
    if (loading) {
      item.classList.add('opacity-50', 'pointer-events-none');
      var spinner = item.querySelector('.cart-item-spinner');
      if (!spinner) {
        spinner = document.createElement('div');
        spinner.className = 'cart-item-spinner absolute inset-0 flex items-center justify-center bg-white/30 z-10';
        spinner.innerHTML = '<svg class="animate-spin h-5 w-5 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';
        item.appendChild(spinner);
      }
    } else {
      item.classList.remove('opacity-50', 'pointer-events-none');
      var spinner = item.querySelector('.cart-item-spinner');
      if (spinner) spinner.remove();
    }
  }

  function changeQuantity(line, quantity) {
    setItemLoading(line, true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function(res) { return res.json(); })
      .then(function(cartData) {
        renderDrawer(cartData);
      })
      .catch(function(err) {
        console.error('[CartDrawer] Erro ao atualizar quantidade:', err);
        setItemLoading(line, false);
      });
  }

  function openDrawer() {
    if (!drawer) return;

    if (isOpen) {
      fetchCartAndRender();
      return;
    }

    isOpen = true;
    drawer.style.display = 'block';
    drawer.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (drawerContent) {
          drawerContent.classList.add('is-open');
          drawerContent.classList.remove('translate-x-full');
          drawerContent.classList.remove('translate-y-full');
        }
      });
    });

    document.body.style.overflow = 'hidden';
    fetchCartAndRender();
  }

  function closeDrawer() {
    if (!drawer || !isOpen) return;
    if (typeof window.closeMobileQuickAdd === 'function') {
      window.closeMobileQuickAdd();
    }
    isOpen = false;
    if (drawerContent) {
      drawerContent.classList.remove('is-open');
    }
    setTimeout(function() {
      drawer.style.display = 'none';
      drawer.setAttribute('aria-hidden', 'true');
    }, 300);
    document.body.style.overflow = '';
  }

  // Event bindings fixos
  if (backdrop) {
    backdrop.addEventListener('click', closeDrawer);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.style.display !== 'none') {
      closeDrawer();
    }
  });

  // Bind direto nos toggles ao invés de delegação
  function bindToggles() {
    var toggles = document.querySelectorAll('[data-cart-drawer-toggle]');
    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });
  }

  bindToggles();
  bindQuantityButtons();
  bindRemoveButtons();

  // ============================================================
  // RECOMMENDATIONS — Cart Drawer Smart Upsells
  // ============================================================

  var recommendationsContainer = document.getElementById('cart-drawer-recommendations');
  var recommendationsLoading = false;
  var lastRecommendedProductId = null;

  function getCartProductIds(cartData) {
    var ids = [];
    cartData.items.forEach(function(item) {
      if (item.product_id) ids.push(item.product_id);
    });
    return ids;
  }

  function filterOutCartProducts(html, cartProductIds) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var cards = doc.querySelectorAll('[data-cart-recommendation-card]');
    var visibleCount = 0;

    cards.forEach(function(card) {
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      if (cartProductIds.indexOf(pid) !== -1) {
        card.remove();
      } else {
        visibleCount++;
      }
    });

    if (visibleCount === 0) return '';

    var wrapper = doc.querySelector('[data-cart-recommendations]');
    return wrapper ? wrapper.outerHTML : '';
  }

  function bindRecommendationButtons() {
    if (!recommendationsContainer) return;

    recommendationsContainer.querySelectorAll('.cart-rec-add-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (btn.disabled) return;

        var card = btn.closest('[data-cart-recommendation-card]');
        var requiresSelection = card && card.getAttribute('data-requires-selection') === 'true';

        if (requiresSelection && typeof window.openMobileQuickAdd === 'function') {
          var jsonScript = card.querySelector('[data-cart-rec-product-json]');
          if (jsonScript) {
            try {
              window.openMobileQuickAdd(JSON.parse(jsonScript.textContent), card);
              return;
            } catch (parseErr) {
              console.error('[CartRecommendations] Erro ao abrir quick add mobile:', parseErr);
            }
          }
        }

        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        var productTitle = btn.getAttribute('data-product-title') || 'Produto';

        // Estado de loading
        btn.disabled = true;
        btn.querySelector('.btn-text').classList.add('hidden');
        btn.querySelector('.btn-spinner').classList.remove('hidden');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              '_source': 'cart_recommendation'
            }
          })
        })
          .then(function(res) {
            if (!res.ok) throw new Error('Add failed');
            return res.json();
          })
          .then(function() {
            // Atualiza o drawer inteiro
            fetchCartAndRender(function() {
              // Feedback visual no botão
              btn.querySelector('.btn-spinner').classList.add('hidden');
              btn.querySelector('.btn-text').textContent = 'Adicionado!';
              btn.querySelector('.btn-text').classList.remove('hidden');
              btn.classList.remove('bg-gray-900', 'hover:bg-gray-800');
              btn.classList.add('bg-green-600', 'hover:bg-green-700');

              // Notificação discreta
              showNotification(productTitle + ' adicionado ao carrinho');

              setTimeout(function() {
                btn.querySelector('.btn-text').textContent = 'Adicionar';
                btn.classList.remove('bg-green-600', 'hover:bg-green-700');
                btn.classList.add('bg-gray-900', 'hover:bg-gray-800');
                btn.disabled = false;
              }, 2000);
            });
          })
          .catch(function(err) {
            console.error('[CartRecommendations] Erro ao adicionar:', err);
            btn.querySelector('.btn-spinner').classList.add('hidden');
            btn.querySelector('.btn-text').textContent = 'Erro';
            btn.querySelector('.btn-text').classList.remove('hidden');
            btn.disabled = false;

            setTimeout(function() {
              btn.querySelector('.btn-text').textContent = 'Adicionar';
            }, 2000);
          });
      });
    });
  }

  function showNotification(message) {
    if (window.showNotification && typeof window.showNotification === 'function') {
      window.showNotification(message);
      return;
    }
    // Fallback simples
    var existing = document.getElementById('cart-drawer-notification');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.id = 'cart-drawer-notification';
    el.className = 'fixed bottom-4 left-1/2 -translate-x-1/2 z-[200] bg-gray-900 text-white text-sm px-4 py-2.5 rounded-lg shadow-lg flex items-center gap-2';
    el.innerHTML = '<svg class="w-4 h-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>' + message;
    document.body.appendChild(el);

    setTimeout(function() {
      el.style.opacity = '0';
      el.style.transition = 'opacity 0.3s';
      setTimeout(function() { el.remove(); }, 300);
    }, 2500);
  }

  function loadRecommendations(cartData) {
    if (!recommendationsContainer || recommendationsLoading) return;
    if (!cartData || cartData.item_count === 0) {
      recommendationsContainer.innerHTML = '';
      return;
    }

    // Usa o primeiro item como produto principal para recomendações
    var primaryItem = cartData.items[0];
    var primaryProductId = primaryItem.product_id;

    if (!primaryProductId) return;

    // Evita reload se o produto principal não mudou
    if (lastRecommendedProductId === primaryProductId && recommendationsContainer.innerHTML.trim().length > 0) {
      // Ainda assim atualiza o filtro de produtos já no carrinho
      var cartProductIds = getCartProductIds(cartData);
      var cards = recommendationsContainer.querySelectorAll('[data-cart-recommendation-card]');
      cards.forEach(function(card) {
        var pid = parseInt(card.getAttribute('data-product-id'), 10);
        if (cartProductIds.indexOf(pid) !== -1) {
          card.style.display = 'none';
        }
      });
      return;
    }

    recommendationsLoading = true;
    lastRecommendedProductId = primaryProductId;

    var sectionId = 'cart-recommendations';
    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'recommendations/products?section_id=' + sectionId + '&product_id=' + primaryProductId + '&limit=4&intent=complementary'
      : '/recommendations/products?section_id=' + sectionId + '&product_id=' + primaryProductId + '&limit=4&intent=complementary';

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var cartProductIds = getCartProductIds(cartData);
        var filteredHtml = filterOutCartProducts(html, cartProductIds);

        if (filteredHtml && filteredHtml.trim().length > 0) {
          recommendationsContainer.innerHTML = filteredHtml;
          bindRecommendationButtons();
        } else {
          recommendationsContainer.innerHTML = '';
        }
      })
      .catch(function(err) {
        console.error('[CartRecommendations] Erro ao carregar:', err);
        recommendationsContainer.innerHTML = '';
      })
      .finally(function() {
        recommendationsLoading = false;
      });
  }

  // Integra recomendações ao ciclo de renderização do drawer
  var originalRenderDrawer = renderDrawer;
  renderDrawer = function(cartData) {
    originalRenderDrawer(cartData);
    // Pequeno delay para garantir que o DOM está pronto
    setTimeout(function() {
      recommendationsContainer = document.getElementById('cart-drawer-recommendations');
      loadRecommendations(cartData);
    }, 50);
  };

  // Expor globalmente
  window.openCartDrawer = openDrawer;
  window.closeCartDrawer = closeDrawer;
  window.refreshCartDrawer = fetchCartAndRender;
})();
